import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { API } from "../api";
import { getPasswordSelector } from "./authSlice";

// ACTIONS --------------------------------------------------------------------

/**
 * @desc Upload a background image.
 */
export const uploadBackgroundImage = createAsyncThunk(
  "webdav/upload/background",
  async ({ image }, { rejectWithValue, dispatch }) => {
    try {
      return (await dispatch(uploadWebdav({ image }))).payload;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * @desc Upload a product image.
 */
export const uploadProductImage = createAsyncThunk(
  "webdav/upload/product",
  async ({ image }, { rejectWithValue, dispatch }) => {
    try {
      return (await dispatch(uploadWebdav({ image }))).payload;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * @desc Upload to webdav.
 */
export const uploadWebdav = createAsyncThunk(
  "webdav/upload",
  async ({ image }, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      if (!state || typeof state !== typeof {}) return;

      const token = getPasswordSelector(state);
      if (!token || !image) return;

      const response = await API.Webdav.Upload({
        payload: image,
        token,
        isForm: true,
      });

      toast.success("Image Uploaded");
      return response;
    } catch (error) {
      toast.error("Failed to Upload Image");
      return rejectWithValue(error);
    }
  }
);
